import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52a7524f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row align-items-center header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "Export")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_5 = { class: "list" }
const _hoisted_6 = { class: "form-floating mb-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Case", -1))
const _hoisted_10 = { class: "form-floating mb-3" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "User Identifier", -1))
const _hoisted_13 = { class: "form-floating mb-3" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tag Identifier", -1))
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = ["value", "disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Start Date", -1))
const _hoisted_20 = { class: "col" }
const _hoisted_21 = ["value", "disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "End Date", -1))
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
            _createElementVNode("button", {
              class: "btn-close",
              type: "button",
              "data-bs-dismiss": "alert",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.error = undefined))
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              placeholder: "Case",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query.game) = $event)),
              disabled: _ctx.disabled
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: index,
                  value: game
                }, _toDisplayString(game), 9, _hoisted_8))
              }), 128))
            ], 8, _hoisted_7), [
              [_vModelSelect, _ctx.query.game]
            ]),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            placeholder: "Identifier",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query.user.id) = $event)),
            disabled: _ctx.disabled
          }, null, 8, _hoisted_11), [
            [_vModelText, _ctx.query.user.id]
          ]),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            placeholder: "Identifier",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.query.tag.id) = $event)),
            disabled: _ctx.disabled
          }, null, 8, _hoisted_14), [
            [_vModelText, _ctx.query.tag.id]
          ]),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_date_picker, {
              modelValue: _ctx.query.start,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.query.start) = $event)),
              class: "form-floating mb-3",
              popover: {
                positionFixed: true,
                placement: _ctx.$screens({default: 'bottom'}),
                visibility: 'click'
              }
            }, {
              default: _withCtx(({inputValue, inputEvents}) => [
                _createElementVNode("input", _mergeProps({
                  class: "form-control",
                  placeholder: "Start Date",
                  value: inputValue
                }, _toHandlers(inputEvents), { disabled: _ctx.disabled }), null, 16, _hoisted_18),
                _hoisted_19
              ]),
              _: 1
            }, 8, ["modelValue", "popover"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_date_picker, {
              modelValue: _ctx.query.end,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.query.end) = $event)),
              class: "form-floating mb-3",
              popover: {
                positionFixed: true,
                placement: _ctx.$screens({default: 'bottom'}),
                visibility: 'click'
              }
            }, {
              default: _withCtx(({inputValue, inputEvents}) => [
                _createElementVNode("input", _mergeProps({
                  class: "form-control",
                  placeholder: "End Date",
                  value: inputValue
                }, _toHandlers(inputEvents), { disabled: _ctx.disabled }), null, 16, _hoisted_21),
                _hoisted_22
              ]),
              _: 1
            }, 8, ["modelValue", "popover"])
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exporter())),
          disabled: _ctx.disabled
        }, " Download ", 8, _hoisted_23)
      ])
    ])
  ]))
}